import { useState, useEffect } from 'react';

import * as authenticationService from '@frolight/services/api/authenticationService';

const useSignIn = ( username, password ) => {

  const [ loading, setLoading ] = useState(false);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  useEffect(() => {
    let mounted = true;

    const abortController = new AbortController();

    const runEffect = async () => {
      if (mounted) setLoading(true);
      try {
        const signInResponse = await authenticationService.signIn(
          abortController,
          {
            username: username,
            password: password
          }
        );
        if (mounted) setData(signInResponse);
      } catch (err) {
        if (mounted) {
          if (err.name !== 'AbortError') {
            setError(err);
          }
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (username && password) {
      runEffect();
    }

    return () => {
      mounted = false;
      abortController.abort();
    }
  }, [ username, password ]);

  return { loading, error, data };
};

export default useSignIn;